import React from 'react';
import Header from './Header';
import Banner from '../common/Banner';

interface DashboardLayoutProps {
    children: React.ReactNode;
    isMember?: boolean;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({children, isMember = true}) => {
    return (
        <div className="bg-mld-background min-h-screen">
            <Header />
            <div className="relative">
                <Banner />
                <main className="container mx-auto px-4 py-12">{children}</main>
                {/* Footer will go here */}

                {/* Blue overlay for non-members - covers everything below header */}
                {!isMember && <div className="absolute inset-0 bg-mld-locked pointer-events-none z-30"></div>}
            </div>
        </div>
    );
};

export default DashboardLayout;
